import { APIClient } from "@/utils/httpClient";
import { APIError } from "@/errors";

export const executeApiCall = async (
    campaignID: string,
    apiConfigID: string,
    userID?: string
) => {
    const response = await APIClient.post(
        `/campaigns/${campaignID}/apiConfigs/${apiConfigID}/execute`,
        {
            userID,
        }
    );
    if (response.success) {
        return response.data;
    } else {
        throw new APIError(response.message);
    }
};
